exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".scroll-wrapper{height:100%;width:100%;overflow:hidden}.scroll-loading{width:20px;height:20px}.pulldown-wrapper{position:absolute;width:100%;left:0;display:flex;justify-content:center;align-items:center;transition:all}.pulldown-wrapper .after-trigger{margin-top:10px}.pullup-wrapper{width:100%;display:flex;justify-content:center;align-items:center;padding:16px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7c2e0d10","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/lib/BScroll.vue
// module id = 6
// module chunks = 0